import { preloaderActionTypes } from './preloader-action-types';



export const addAssets = (assets) => {
			
    return {
        type: preloaderActionTypes.PRELOADER_ADD_FILES,
        assets       
    };
};

export const addAlbumAssets = (albumArray) => {
    var assets = [];
    albumArray.forEach(album => {
        if(album.elementType === "photo" && album.resolutions != null && album.resolutions.PHOTO_XLARGE != null){
        assets.push(album.resolutions.PHOTO_XLARGE);
        } 
    
});
			
    return {
        type: preloaderActionTypes.PRELOADER_ADD_FILES,
        assets       
    };
};

export const assetProcessed = (asset) => {
			
    return {
        type: preloaderActionTypes.PRELOADER_FILE_LOADED,
        asset       
    };
};

export const clearPreloaded = () => {
    return {
        type: preloaderActionTypes.PRELOADER_CLEAR_FILES,
             
    };
};


// WEBPACK FOOTER //
// ./src/preloader/actions/preloader-actions.js